<app-header *ngIf="shouldShowHeader"></app-header>
<router-outlet></router-outlet>
<!-- One notification surface for the whole console, mounted once. Outside the
     router outlet so a message survives the navigation that raised it. -->
<app-notify-host></app-notify-host>
<app-ai-chat-widget *ngIf="shouldShowHeader && !isAiPage"></app-ai-chat-widget>
